/* ymm.js */
/* ==========================================================
   Year / Make / Model data for the promo popup.
   Years: 2026 back to 1996 (the range the 5610 supports).
   Models cover the major US/Canada market makes; any make
   without a list (or an unlisted model) falls back to the
   "Not listed here" option that the popup appends automatically.
   ========================================================== */
window.YMM = {
  makes: [
    "Acura","Alfa Romeo","Audi","BMW","Buick","Cadillac","Chevrolet","Chrysler","Dodge","Fiat",
    "Ford","Genesis","GMC","Honda","Hummer","Hyundai","Infiniti","Isuzu","Jaguar","Jeep","Kia",
    "Land Rover","Lexus","Lincoln","Maserati","Mazda","Mercedes-Benz","Mercury","Mini","Mitsubishi",
    "Nissan","Oldsmobile","Plymouth","Pontiac","Porsche","Ram","Saab","Saturn","Scion","Subaru",
    "Suzuki","Tesla","Toyota","Volkswagen","Volvo"
  ],
  models: {
    "Acura": ["ILX","TLX","TL","TSX","RLX","RL","MDX","RDX","ZDX","Integra","NSX","CL","Legend"],
    "Alfa Romeo": ["Giulia","Stelvio","4C","Giulietta","Tonale"],
    "Audi": ["A3","A4","A4 allroad","A5","A6","A7","A8","Q3","Q5","Q7","Q8","e-tron","TT","R8","S3","S4","S5","RS 5","allroad"],
    "BMW": ["2 Series","3 Series","4 Series","5 Series","6 Series","7 Series","8 Series","X1","X2","X3","X4","X5","X6","X7","Z4","i3","i4","iX","M3","M4","M5"],
    "Buick": ["Enclave","Encore","Encore GX","Envision","LaCrosse","Regal","Verano","Lucerne","Century","LeSabre","Rendezvous","Cascada","Rainier"],
    "Cadillac": ["ATS","CTS","CT4","CT5","CT6","XTS","XT4","XT5","XT6","Escalade","SRX","DTS","STS","DeVille","Eldorado","Lyriq"],
    "Chevrolet": ["Silverado 1500","Silverado 2500HD","Colorado","Camaro","Corvette","Malibu","Impala","Cruze","Sonic","Spark","Equinox","Traverse","Tahoe","Suburban","Blazer","Trax","Trailblazer","Bolt EV","Volt","Cobalt","Aveo","HHR","Express","Avalanche","S-10","Monte Carlo"],
    "Chrysler": ["300","200","Pacifica","Town & Country","Sebring","PT Cruiser","Voyager","Aspen","Crossfire","Concorde"],
    "Dodge": ["Charger","Challenger","Durango","Journey","Grand Caravan","Dart","Avenger","Caliber","Nitro","Magnum","Neon","Stratus","Intrepid","Dakota","Viper"],
    "Fiat": ["500","500L","500X","124 Spider"],
    "Ford": ["F-150","F-250 Super Duty","F-350 Super Duty","Ranger","Maverick","Mustang","Explorer","Escape","Edge","Expedition","Bronco","Bronco Sport","Focus","Fusion","Fiesta","Taurus","Escort","Flex","EcoSport","Transit","Transit Connect","Crown Victoria","Five Hundred","Freestyle","Freestar","Windstar"],
    "Genesis": ["G70","G80","G90","GV60","GV70","GV80"],
    "GMC": ["Sierra 1500","Sierra 2500HD","Canyon","Yukon","Yukon XL","Acadia","Terrain","Savana","Envoy","Jimmy","Sonoma","Hummer EV"],
    "Honda": ["Accord","Civic","CR-V","Pilot","Odyssey","HR-V","Ridgeline","Passport","Fit","Insight","Element","CR-Z","Crosstour","S2000","Prelude","Accord Crosstour"],
    "Hummer": ["H1","H2","H3","H3T"],
    "Hyundai": ["Elantra","Sonata","Accent","Tucson","Santa Fe","Kona","Palisade","Veloster","Genesis","Azera","Ioniq","Ioniq 5","Venue","Santa Cruz","Nexo","Tiburon","Entourage","Equus","Veracruz","Santa Fe Sport"],
    "Infiniti": ["Q50","Q60","Q70","QX50","QX55","QX60","QX70","QX80","G35","G37","FX35","FX45","M35","M45","EX35","JX35","I30","QX4","QX56"],
    "Isuzu": ["Rodeo","Trooper","Ascender","i-Series","Axiom","Amigo","VehiCROSS"],
    "Jaguar": ["XE","XF","XJ","F-Type","F-Pace","E-Pace","I-Pace","S-Type","X-Type","XK"],
    "Jeep": ["Wrangler","Grand Cherokee","Cherokee","Compass","Renegade","Gladiator","Patriot","Liberty","Commander","Wagoneer","Grand Wagoneer","Grand Cherokee L"],
    "Kia": ["Optima","Forte","Rio","Soul","Sportage","Sorento","Telluride","Seltos","Stinger","Sedona","Carnival","Niro","K5","Cadenza","Spectra","Amanti","Sephia","Borrego","Rondo"],
    "Land Rover": ["Range Rover","Range Rover Sport","Range Rover Evoque","Range Rover Velar","Discovery","Discovery Sport","Defender","LR2","LR3","LR4","Freelander"],
    "Lexus": ["ES","IS","GS","LS","RC","LC","NX","RX","GX","LX","UX","CT","HS","SC","RZ","IS F"],
    "Lincoln": ["MKZ","MKS","MKX","MKC","MKT","Continental","Navigator","Aviator","Corsair","Nautilus","Town Car","LS","Zephyr","Mark LT"],
    "Maserati": ["Ghibli","Quattroporte","Levante","GranTurismo","GranCabrio","Grecale","Coupe"],
    "Mazda": ["Mazda3","Mazda6","CX-3","CX-30","CX-5","CX-9","CX-50","CX-90","MX-5 Miata","Mazda2","Tribute","CX-7","RX-8","Protege","Millenia","MPV","B-Series","MX-30"],
    "Mercedes-Benz": ["A-Class","C-Class","E-Class","S-Class","CLA","CLS","GLA","GLB","GLC","GLE","GLS","G-Class","SL","SLC","SLK","CLK","ML-Class","GL-Class","GLK-Class","Metris","Sprinter","EQS","EQE"],
    "Mercury": ["Grand Marquis","Milan","Sable","Mariner","Mountaineer","Montego","Cougar","Villager","Marauder"],
    "Mini": ["Cooper","Cooper Clubman","Cooper Countryman","Paceman","Convertible","Hardtop"],
    "Mitsubishi": ["Outlander","Outlander Sport","Eclipse Cross","Mirage","Lancer","Eclipse","Galant","Endeavor","Montero","Montero Sport","Raider","Diamante","Mirage G4"],
    "Nissan": ["Altima","Sentra","Maxima","Versa","Rogue","Rogue Sport","Murano","Pathfinder","Armada","Frontier","Titan","Kicks","Juke","Leaf","370Z","350Z","GT-R","Cube","Quest","Xterra","Ariya","Z","NV200"],
    "Oldsmobile": ["Alero","Aurora","Intrigue","Bravada","Silhouette","Cutlass","Eighty-Eight","Achieva","Regency"],
    "Plymouth": ["Neon","Breeze","Voyager","Prowler","Grand Voyager"],
    "Pontiac": ["Grand Prix","Grand Am","G6","G8","G5","G3","Vibe","Bonneville","Firebird","GTO","Solstice","Torrent","Aztek","Montana","Sunfire","Trans Sport"],
    "Porsche": ["911","718 Cayman","718 Boxster","Cayenne","Macan","Panamera","Taycan","Boxster","Cayman"],
    "Ram": ["1500","2500","3500","ProMaster","ProMaster City","Dakota"],
    "Saab": ["9-3","9-5","9-7X","9-2X","900"],
    "Saturn": ["Ion","Aura","Vue","Outlook","Sky","Relay","L-Series","S-Series"],
    "Scion": ["tC","xB","xD","xA","FR-S","iA","iM","iQ"],
    "Subaru": ["Outback","Forester","Crosstrek","Impreza","Legacy","Ascent","WRX","BRZ","Baja","Tribeca","Solterra","SVX"],
    "Suzuki": ["Grand Vitara","SX4","Kizashi","Forenza","Aerio","XL-7","Reno","Verona","Equator","Vitara","Esteem"],
    "Tesla": ["Model 3","Model S","Model X","Model Y","Roadster","Cybertruck"],
    "Toyota": ["Camry","Corolla","Prius","RAV4","Highlander","4Runner","Tacoma","Tundra","Sienna","Sequoia","Avalon","Yaris","C-HR","Venza","Land Cruiser","Supra","86","GR86","GR Corolla","Matrix","Solara","FJ Cruiser","Echo","bZ4X","Corolla Cross","Prius Prime"],
    "Volkswagen": ["Jetta","Passat","Golf","GTI","Golf R","Tiguan","Atlas","Atlas Cross Sport","Beetle","Arteon","Taos","ID.4","Touareg","CC","Eos","Rabbit","Routan","GLI"],
    "Volvo": ["S60","S90","V60","V90","XC40","XC60","XC90","S40","S80","V50","V70","C30","C70","XC70"]
  }
};


/* script-c.js */
/* ==========================================================
   INNOVA 5610 — interactions present in the design
   ========================================================== */
(function () {
  'use strict';

  /* ---------- star ratings ---------- */
  var STAR = 'M12 2.6l2.9 5.9 6.5.95-4.7 4.58 1.11 6.47L12 17.45 6.19 20.5 7.3 14.03 2.6 9.45l6.5-.95z';
  document.querySelectorAll('[data-stars]').forEach(function (el) {
    var v = parseFloat(el.getAttribute('data-stars')) || 5, html = '';
    for (var i = 1; i <= 5; i++) {
      var fill = v >= i ? 1 : (v > i - 1 ? v - (i - 1) : 0);
      if (fill === 1) {
        html += '<svg viewBox="0 0 24 24"><path d="' + STAR + '"/></svg>';
      } else if (fill === 0) {
        html += '<svg viewBox="0 0 24 24" style="fill:#c9c9c9"><path d="' + STAR + '"/></svg>';
      } else {
        var id = 'g' + Math.random().toString(36).slice(2, 8);
        html += '<svg viewBox="0 0 24 24"><defs><linearGradient id="' + id + '">' +
          '<stop offset="' + (fill * 100) + '%" stop-color="currentColor"/>' +
          '<stop offset="' + (fill * 100) + '%" stop-color="#c9c9c9"/></linearGradient></defs>' +
          '<path d="' + STAR + '" fill="url(#' + id + ')"/></svg>';
      }
    }
    el.innerHTML = html;
  });

  /* ---------- hero video: play once, then settle on the product still ---------- */
  var heroVideo = document.getElementById('heroVideo');
  var heroMedia = document.getElementById('heroMedia');
  if (heroVideo) {
    heroVideo.loop = false;
    heroVideo.addEventListener('ended', function () {
      heroVideo.pause();
      if (heroMedia) heroMedia.classList.add('ended'); // fade in High-Res still
    });
  }

  /* ---------- reviews carousel (Scotty + testimonials) ---------- */
  var rstage = document.getElementById('rstage');
  var rdots = document.getElementById('rdots');
  if (rstage && rdots) {
    var slides = rstage.querySelectorAll('.rslide');
    var dots = rdots.querySelectorAll('i');
    var show = function (n) {
      slides.forEach(function (s, i) { s.classList.toggle('on', i === n); });
      dots.forEach(function (d, i) { d.classList.toggle('on', i === n); });
    };
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); }); });
  }

  /* ---------- "Speak your car's language" expanding gallery ---------- */
  var cards = document.getElementById('cards');
  if (cards) {
    var items = cards.querySelectorAll('.c');
    items.forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.classList.contains('open')) return;   // only one open at a time
        items.forEach(function (x) { x.classList.remove('open'); });
        c.classList.add('open');
      });
    });
  }

  /* ---------- product gallery thumbnails ---------- */
  var thumbs = document.getElementById('galThumbs');
  if (thumbs) {
    var main = document.getElementById('galMain');
    thumbs.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        main.src = b.getAttribute('data-src');
      });
    });
  }

  /* ---------- purchase options ---------- */
  var opts = document.getElementById('opts');
  if (opts) {
    var labels = opts.querySelectorAll('.opt');
    labels.forEach(function (l) {
      l.addEventListener('click', function () {
        labels.forEach(function (x) { x.classList.remove('on'); });
        l.classList.add('on');
        l.querySelector('input').checked = true;
      });
    });
  }

  /* ---------- awards: duplicate items for the seamless mobile marquee ---------- */
  var awTrack = document.querySelector('.awards .aw-track');
  if (awTrack) {
    awTrack.querySelectorAll('.aw').forEach(function (aw) {
      var c = aw.cloneNode(true);
      c.classList.add('aw-clone');
      c.setAttribute('aria-hidden', 'true');
      awTrack.appendChild(c);
    });
  }

  /* ---------- live-data pulse: build a repeating ECG waveform ---------- */
  (function () {
    var svg = document.querySelector('.pulse-svg');
    if (!svg) return;
    var W = 1200, mid = 100, beats = 4, seg = W / beats, d = 'M0 ' + mid;
    for (var i = 0; i < beats; i++) {
      var x = i * seg;
      d += ' L' + (x + seg * 0.42) + ' ' + mid;                                   // flat
      d += ' Q' + (x + seg * 0.48) + ' ' + (mid - 14) + ' ' + (x + seg * 0.54) + ' ' + mid; // P wave
      d += ' L' + (x + seg * 0.58) + ' ' + mid;
      d += ' L' + (x + seg * 0.60) + ' ' + (mid + 18);                            // Q
      d += ' L' + (x + seg * 0.63) + ' ' + (mid - 70);                            // R spike
      d += ' L' + (x + seg * 0.66) + ' ' + (mid + 34);                            // S
      d += ' L' + (x + seg * 0.69) + ' ' + mid;
      d += ' Q' + (x + seg * 0.80) + ' ' + (mid - 22) + ' ' + (x + seg * 0.88) + ' ' + mid; // T wave
      d += ' L' + (x + seg) + ' ' + mid;
    }
    svg.querySelectorAll('path').forEach(function (p) { p.setAttribute('d', d); });
  })();

  /* ---------- "does it work on my car?" fit checker ---------- */
  (function () {
    var toggle = document.getElementById('fitToggle');
    var panel = document.getElementById('fitPanel');
    var yearSel = document.getElementById('fitYear');
    var makeSel = document.getElementById('fitMake');
    var modelSel = document.getElementById('fitModel');
    var result = document.getElementById('fitResult');
    var resultHead = document.querySelector('.fit-result b');
    var resultText = document.getElementById('fitResultText');
    if (!panel || !yearSel || !window.YMM) return;   // VARIANT B: toggle is optional (panel shown openly)

    // keep the promise honest: exclude EV-only brand, EVs, and heavy-duty / commercial models
    var EX_MAKES = { 'Tesla': 1 };
    // brands with no OBD1-era (pre-1996) US presence — hidden when an older year is picked
    var EX_MAKES_PRE96 = { 'Genesis': 1, 'Scion': 1, 'Mini': 1, 'Ram': 1, 'Fiat': 1, 'Kia': 1,
      'Alfa Romeo': 1, 'Maserati': 1, 'Hummer': 1 };
    var EX_MODELS = {};
    ['e-tron', 'i3', 'i4', 'iX', 'Bolt EV', 'Lyriq', 'Ioniq 5', 'Nexo', 'I-Pace', 'EQS', 'EQE', 'Leaf',
     'Ariya', 'Taycan', 'Solterra', 'bZ4X', 'ID.4', 'RZ', 'GV60', 'Hummer EV', 'H1',
     'F-250 Super Duty', 'F-350 Super Duty', 'Silverado 2500HD', 'Sierra 2500HD', '2500', '3500',
     'ProMaster', 'ProMaster City', 'Express', 'Savana', 'Sprinter', 'Transit', 'Transit Connect',
     'Metris', 'NV200'].forEach(function (m) { EX_MODELS[m] = 1; });

    var HEADERS = ['Nice choice!', "That's a nice ride.", 'Great taste!', 'Solid pick.', 'Ooh, good one.'];
    var headIdx = 0;

    var opt = function (sel, label, value) {
      var o = document.createElement('option');
      o.textContent = label; o.value = (value === undefined ? label : value);
      sel.appendChild(o); return o;
    };
    var isPre96 = function () { var y = parseInt(yearSel.value, 10); return !!y && y <= 1995; };

    // Years: 2026 shown as "coming soon" (disabled), selectable 2025 down to 1990 (OBD1 era)
    yearSel.innerHTML = '<option value="" selected disabled>Year</option>';
    var soon = opt(yearSel, '2026 (Coming soon)', ''); soon.disabled = true;
    for (var y = 2025; y >= 1990; y--) opt(yearSel, String(y));

    var fillMakes = function () {
      var cur = makeSel.value, pre = isPre96();
      makeSel.innerHTML = '<option value="" selected disabled>Make</option>';
      window.YMM.makes.forEach(function (m) {
        if (EX_MAKES[m]) return;
        if (pre && EX_MAKES_PRE96[m]) return;
        opt(makeSel, m);
      });
      if (cur) { makeSel.value = cur; if (makeSel.value !== cur) makeSel.selectedIndex = 0; }
    };
    var fillModels = function () {
      var cur = modelSel.value;
      modelSel.innerHTML = '<option value="" selected disabled>Model</option>';
      (window.YMM.models[makeSel.value] || []).forEach(function (m) { if (!EX_MODELS[m]) opt(modelSel, m); });
      modelSel.disabled = !makeSel.value;
      if (cur) { modelSel.value = cur; if (modelSel.value !== cur) modelSel.selectedIndex = 0; }
    };
    var showResult = function () {
      if (yearSel.value && makeSel.value && modelSel.value) {
        resultHead.textContent = HEADERS[headIdx % HEADERS.length]; headIdx++;
        var msg = 'The Innova 5610 works with your ' + yearSel.value + ' ' + makeSel.value + ' ' + modelSel.value + '.';
        if (isPre96()) msg += ' Just add a separate OBD1 adapter (available at innova.com).';
        resultText.textContent = msg;
        result.hidden = false;
      } else {
        result.hidden = true;
      }
    };

    yearSel.addEventListener('change', function () { fillMakes(); fillModels(); showResult(); });
    makeSel.addEventListener('change', function () { fillModels(); showResult(); });
    modelSel.addEventListener('change', showResult);
    if (toggle) toggle.addEventListener('click', function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
    });

    // clean state on load / bfcache restore (don't let the browser keep a stale result showing)
    var reset = function () {
      yearSel.selectedIndex = 0;
      fillMakes(); makeSel.selectedIndex = 0;
      modelSel.innerHTML = '<option value="" selected disabled>Model</option>'; modelSel.disabled = true;
      result.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');   // VARIANT B: panel stays open, don't hide it
    };
    reset();
    window.addEventListener('pageshow', function (e) { if (e.persisted) reset(); });
  })();

  /* ---------- accordions (buy box + FAQ) ---------- */
  function accordion(root) {
    if (!root) return;
    root.querySelectorAll('.it').forEach(function (item) {
      var q = item.querySelector('.q'), a = item.querySelector('.a');
      if (item.classList.contains('open')) a.style.maxHeight = a.scrollHeight + 'px';
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        root.querySelectorAll('.it.open').forEach(function (o) {
          o.classList.remove('open');
          o.querySelector('.a').style.maxHeight = null;
        });
        if (!isOpen) {
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }
  accordion(document.getElementById('acc'));
  accordion(document.getElementById('faq'));

  /* ---------- countdown ---------- */
  var timer = document.getElementById('timer');
  if (timer) {
    var KEY = 'innova5610_deadline';
    var deadline = parseInt(localStorage.getItem(KEY), 10);
    var now = Date.now();
    if (!deadline || deadline < now || deadline - now > 7 * 3600 * 1000) {
      deadline = now + 5 * 3600 * 1000 + 2 * 60 * 1000 + 45 * 1000;
      localStorage.setItem(KEY, String(deadline));
    }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var d = Math.max(0, deadline - Date.now());
      timer.textContent = Math.floor(d / 3600000) + ':' +
        pad(Math.floor((d % 3600000) / 60000)) + ':' + pad(Math.floor((d % 60000) / 1000));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- modals (features + 3360 camera) ---------- */
  function wireModal(modal, openBtn) {
    if (!modal) return;
    var open = function () {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      modal.querySelectorAll('video').forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    };
    var close = function () {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
    };
    if (openBtn) {
      if (openBtn.forEach) openBtn.forEach(function (b) { if (b) b.addEventListener('click', open); });
      else openBtn.addEventListener('click', open);
    }
    modal.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });
  }
  wireModal(document.getElementById('featModal'), document.querySelectorAll('.js-feat-open'));
  wireModal(document.getElementById('cam3360Modal'), document.getElementById('cam3360Open'));

  /* ---------- influencer videos: tap to unmute (one at a time) ---------- */
  (function () {
    var figs = [].slice.call(document.querySelectorAll('.infl'));
    if (!figs.length) return;
    figs.forEach(function (fig) {
      var vid = fig.querySelector('video');
      var btn = fig.querySelector('.infl-sound');
      if (!vid) return;
      var toggle = function (e) {
        if (e) e.preventDefault();
        var turnOn = vid.muted;
        figs.forEach(function (f) {
          var v = f.querySelector('video');
          if (v) v.muted = true;
          f.classList.remove('on');
        });
        if (turnOn) {
          vid.muted = false;
          var p = vid.play(); if (p && p.catch) p.catch(function () {});
          fig.classList.add('on');
        }
      };
      if (btn) btn.addEventListener('click', toggle);
      vid.addEventListener('click', toggle);
    });
  })();

  /* ---------- scarcity: live stock counter ---------- */
  var stockLeft = document.getElementById('stockLeft');
  var scarFill = document.getElementById('scarFill');
  if (stockLeft && scarFill) {
    var pct = 4; // % of the bundle left
    var render = function () {
      stockLeft.textContent = pct + '%';
      scarFill.style.width = (100 - pct) + '%';
    };
    render();
    setInterval(function () {
      if (pct > 2 && Math.random() < 0.55) {
        pct = Math.max(2, Math.round((pct - (Math.random() * 0.3 + 0.1)) * 10) / 10);
        render();
      }
    }, 8000);
  }

  /* ---------- delivery date: 2 days ahead (PST) ---------- */
  var deliveryEl = document.getElementById('deliveryDate');
  if (deliveryEl) {
    try {
      var future = new Date(Date.now() + 2 * 86400000);
      deliveryEl.textContent = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles', weekday: 'long', month: 'long', day: 'numeric'
      }).format(future);
    } catch (e) { /* leave fallback text */ }
  }

  /* ---------- checkout: slide-in cart, then the pre-filled cart URL ---------- */
  var CART_BASE = 'https://www.innova.com/cart/32524554436654:1,41990059687982:1,41968968794158:1,41990063915054:1,39553005617198:1?discount=5610_BOGO3360N,5610_PARTNERSHIPS_FP';
  var CART_EMAIL = CART_BASE + ',CRX2000';
  // sale cart: no 3360 camera variant; 5610_PARTNERSHIP + 5610_PARTNERSHIPS_FP bring it to $269
  var SALE_CART = 'https://www.innova.com/cart/32524554436654:1,41990059687982:1,41968968794158:1,41990063915054:1?discount=5610_PARTNERSHIP,5610_PARTNERSHIPS_FP';
  var cartGo = document.getElementById('cartGo');
  var crowEmail = document.getElementById('crowEmail');
  var cartTotal = document.getElementById('cartTotal');

  var saleActive = false, salePriceStr = '$269', promoActive = false, promoCfg = null;
  var setCheckout = function (url) {
    var withEmail = !saleActive && (url === CART_EMAIL);
    // real navigation targets (also the JS-disabled fallback for anchor triggers)
    document.querySelectorAll('.js-checkout').forEach(function (a) { if (a.tagName === 'A') a.setAttribute('href', url); });
    if (cartGo) cartGo.setAttribute('href', url);
    if (crowEmail) crowEmail.hidden = !withEmail;      // CRX2000 line only when email captured AND not on sale
    if (cartTotal) cartTotal.textContent = saleActive ? salePriceStr : (withEmail ? '$329' : '$349');
  };
  var emailCaptured = false;
  try { emailCaptured = !!localStorage.getItem('innova_email_captured'); } catch (e) {}
  setCheckout(emailCaptured ? CART_EMAIL : CART_BASE);

  /* ---------- Shop Pay Installments modal: check out with the whole bundle ----------
     Shopify's "Continue to checkout" button builds /cart/<5610 variant>:1 by itself, so the
     free case, app, shipping, camera and discount codes all drop off. Catch the click in the
     capture phase, before Shopify's own handler runs, and send it to the same cart link the
     rest of the page uses, so whichever offer the visitor picked comes through intact.
     The modal lives in an open shadow root, which composedPath() can see into. If Shopify
     ever renames the hook, nothing matches and their default behaviour simply returns. */
  window.addEventListener('click', function (e) {
    var path = e.composedPath ? e.composedPath() : [];
    var hit = path.some(function (n) {
      return n && n.getAttribute && n.getAttribute('data-testid') === 'sample-plans-modal-continue-to-checkout-button';
    });
    if (!hit || !cartGo) return;
    var url = cartGo.getAttribute('href');
    if (!url || url === '#') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    // payment=shop_pay_installments is the parameter Shopify's own button adds: it opens Shop Pay
    // with installments selected. Checked that both offers keep every free item and discount code
    // through that handoff. Only this modal button uses it; the page's main CTA stays on the
    // regular checkout so shoppers paying in full are not routed through a Shop Pay sign-in.
    window.location.href = url + (url.indexOf('?') < 0 ? '?' : '&') + 'payment=shop_pay_installments';
  }, true);

  /* ---------- scheduled sale mode (driven by a Google Sheet, times in PST) ---------- */
  /* SETUP: make a sheet with headers  Start (PST) | End (PST) | Price | 3360 Camera
     Start/End = "YYYY-MM-DD HH:MM" Pacific (e.g. 2026-08-01 00:00). Price = e.g. 269.
     3360 Camera = "No" to drop the free camera (default is to drop it during any sale).
     File -> Share -> Publish to web -> CSV, then paste that link below. */
  var SALE_SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR8_-VBtZsinlLkdfa5JdAKT7_27Y0l839zMT_yXsD5qtTwCpcxBcQN0yfgjeZ_Hg5opfnYmNfFUDrb/pub?output=csv';
  var MSRP = 549, F_CAM = 200, F_BOOT = 20, F_APP = 99, F_SHIP = 10;

  var applySale = function (cfg) {
    saleActive = true;
    var price = cfg.price, keepCam = !!cfg.camera;
    salePriceStr = '$' + price;
    var value = MSRP + (keepCam ? F_CAM : 0) + F_BOOT + F_APP + F_SHIP;
    var save = value - price, pct = Math.round(save / value * 100), off = MSRP - price;
    document.body.classList.add('sale-mode');
    var set = function (id, html) { var el = document.getElementById(id); if (el) el.innerHTML = html; };
    set('barMsg', 'FLASH SALE: Get $' + off + ' OFF — the Innova 5610 is now just $' + price);
    set('dealBadge', 'FLASH SALE');
    // Flash deal is the lowest cash price, not a bigger % than the camera bundle (both ~60% of their
    // own value), so lead with "Best price" here and keep the concrete $ in the "You save" button.
    set('dealPill', 'Best price');
    set('dealScanPrice', '<s>$' + MSRP + '</s> $' + price);
    set('dealPrice', '$' + price);
    set('dealValue', '$' + value + ' total value');
    set('dealSave', 'You save $' + save + ' &rarr;');
    set('vsCost', '$' + price);
    set('cartCount', (keepCam ? 5 : 4) + ' items');
    set('cartSaveText', '$' + save + ' · best price');
    set('cartScanPrice', '$' + price);
    set('cartRetail', '$' + value);
    set('cartDiscount', '−$' + save);
    setCheckout(keepCam ? CART_BASE : SALE_CART);
  };

  /* ---------- announcement-bar phrase: auto-swap the lead on holiday weekends (Pacific) ---------- */
  /* Only the words before the first colon change (e.g. "SPECIAL OFFER" -> "LABOR DAY SALE"); the rest
     of the banner is untouched. Rule-based dates = no yearly upkeep. A live flash sale still overrides
     this via applySale(). Runs BEFORE the NORMAL capture so the toggle restores the holiday phrase. */
  (function () {
    var barMsgEl = document.getElementById('barMsg');
    if (!barMsgEl) return;
    var addDays = function (d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); };
    var nthWeekday = function (y, m, wd, n) { var d = new Date(y, m, 1); var s = (wd - d.getDay() + 7) % 7; return new Date(y, m, 1 + s + (n - 1) * 7); };
    var lastWeekday = function (y, m, wd) { var d = new Date(y, m + 1, 0); var s = (d.getDay() - wd + 7) % 7; return addDays(d, -s); };
    var windowsFor = function (Y) {
      var tg = nthWeekday(Y, 10, 4, 4); // Thanksgiving = 4th Thursday of November
      return [
        { lead: 'NEW YEAR SALE',        start: new Date(Y, 0, 1),   end: new Date(Y, 0, 1) },
        { lead: "PRESIDENTS' DAY SALE", start: addDays(nthWeekday(Y, 1, 1, 3), -3), end: nthWeekday(Y, 1, 1, 3) },
        { lead: 'MEMORIAL DAY SALE',    start: addDays(lastWeekday(Y, 4, 1), -3), end: lastWeekday(Y, 4, 1) },
        { lead: '4TH OF JULY SALE',     start: new Date(Y, 6, 1),   end: new Date(Y, 6, 5) },
        { lead: 'LABOR DAY SALE',       start: addDays(nthWeekday(Y, 8, 1, 1), -3), end: nthWeekday(Y, 8, 1, 1) },
        { lead: 'BLACK FRIDAY SALE',    start: tg,                  end: addDays(tg, 3) },
        { lead: 'CYBER MONDAY SALE',    start: addDays(tg, 4),      end: addDays(tg, 4) },
        { lead: 'CHRISTMAS SALE',       start: new Date(Y, 11, 10), end: new Date(Y, 11, 25) },
        { lead: 'NEW YEAR SALE',        start: new Date(Y, 11, 26), end: new Date(Y, 11, 31) }
      ];
    };
    var pac;
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach(function (x) { g[x.type] = x.value; });
      pac = new Date(parseInt(g.year, 10), parseInt(g.month, 10) - 1, parseInt(g.day, 10));
    } catch (e) { pac = new Date(); }
    var W = windowsFor(pac.getFullYear()), t = pac.getTime(), lead = null;
    for (var i = 0; i < W.length; i++) { if (t >= W[i].start.getTime() && t <= W[i].end.getTime()) { lead = W[i].lead; break; } }
    if (lead) barMsgEl.innerHTML = barMsgEl.innerHTML.replace(/^[^:]*:/, lead + ':');
  })();

  /* capture the normal (non-sale) copy so the toggle can switch back to it */
  var NORMAL = {};
  ['barMsg', 'dealBadge', 'dealPill', 'dealScanPrice', 'dealPrice', 'dealValue', 'dealSave', 'vsCost',
   'cartCount', 'cartSaveText', 'cartScanPrice', 'cartRetail', 'cartDiscount'].forEach(function (id) {
    var el = document.getElementById(id); if (el) NORMAL[id] = el.innerHTML;
  });
  var applyNormal = function () {
    saleActive = false;
    document.body.classList.remove('sale-mode');
    Object.keys(NORMAL).forEach(function (id) { var el = document.getElementById(id); if (el) el.innerHTML = NORMAL[id]; });
    setCheckout(emailCaptured ? CART_EMAIL : CART_BASE);
  };

  /* promo toggle: default = discounted (applySale); alt = full price + free camera (applyNormal) */
  var dealToggle = document.getElementById('dealToggle');
  var setToggleUI = function (mode) {
    if (!dealToggle) return;
    dealToggle.querySelectorAll('[data-offer]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-offer') === mode); });
  };
  var activatePromo = function (cfg) {
    promoActive = true; promoCfg = cfg;
    if (dealToggle) dealToggle.hidden = false;
    applySale(cfg);               // default to the discount
    setToggleUI('sale');
  };
  if (dealToggle) dealToggle.querySelectorAll('[data-offer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.getAttribute('data-offer');
      if (mode === 'sale') applySale(promoCfg); else applyNormal();
      setToggleUI(mode);
    });
  });

  var pacificNow = function () {
    try {
      var g = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit',
        day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date())
        .forEach(function (x) { g[x.type] = x.value; });
      return g.year + '-' + g.month + '-' + g.day + ' ' + (g.hour === '24' ? '00' : g.hour) + ':' + g.minute;
    } catch (e) { return null; }
  };
  // normalize whatever Google Sheets exports into a zero-padded "YYYY-MM-DD HH:MM" so string compare is safe
  var toKey = function (s) {
    s = (s || '').trim(); if (!s) return '';
    var dm = s.match(/(\d{4})[-/](\d{1,2})[-/](\d{1,2})/) || s.match(/(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
    if (!dm) return '';
    var y, mo, d;
    if (dm[1].length === 4) { y = dm[1]; mo = dm[2]; d = dm[3]; } else { mo = dm[1]; d = dm[2]; y = dm[3]; }
    var hh = 0, mm = 0, tm = s.match(/(\d{1,2}):(\d{2})\s*([ap]m)?/i);
    if (tm) {
      hh = parseInt(tm[1], 10); mm = parseInt(tm[2], 10);
      var ap = (tm[3] || '').toLowerCase();
      if (ap === 'pm' && hh < 12) hh += 12;
      if (ap === 'am' && hh === 12) hh = 0;
    }
    var p = function (n, w) { n = String(parseInt(n, 10) || 0); while (n.length < w) n = '0' + n; return n; };
    return p(y, 4) + '-' + p(mo, 2) + '-' + p(d, 2) + ' ' + p(hh, 2) + ':' + p(mm, 2);
  };

  var checkSale = function (rows) {
    var now = pacificNow(); if (!now) return;
    for (var i = 0; i < rows.length; i++) {
      var start = toKey(rows[i].start), end = toKey(rows[i].end);
      if (start && end && start <= now && now < end) {
        activatePromo({ price: parseInt(rows[i].price, 10) || 269, camera: /^\s*(yes|true|1)\s*$/i.test(rows[i].camera || '') });
        return;
      }
    }
  };
  var parseCSV = function (text) {
    var lines = text.split(/\r?\n/).filter(function (l) { return l.trim(); });
    if (lines.length < 2) return [];
    var head = lines[0].split(',').map(function (h) { return h.trim().toLowerCase().replace(/^"|"$/g, ''); });
    var find = function (names) { for (var i = 0; i < head.length; i++) for (var j = 0; j < names.length; j++) if (head[i].indexOf(names[j]) === 0) return i; return -1; };
    var iS = find(['start']), iE = find(['end']), iP = find(['price']), iC = find(['3360', 'camera']);
    var rows = [];
    for (var k = 1; k < lines.length; k++) {
      var c = lines[k].split(',').map(function (v) { return v.trim().replace(/^"|"$/g, ''); });
      rows.push({ start: c[iS], end: c[iE], price: iP >= 0 ? c[iP] : '', camera: iC >= 0 ? c[iC] : '' });
    }
    return rows;
  };

  if (/[?&]sale=preview/.test(location.search)) {
    activatePromo({ price: 269, camera: false });             // test the promo layout without a live window
  } else if (SALE_SHEET_URL) {
    fetch(SALE_SHEET_URL + (SALE_SHEET_URL.indexOf('?') >= 0 ? '&' : '?') + '_cb=' + Math.floor(Date.now() / 60000))
      .then(function (r) { return r.text(); })
      .then(function (t) { checkSale(parseCSV(t)); })
      .catch(function () { /* network/CORS failure -> stay in normal mode (fail safe) */ });
  }

  /* An open promo popup / modal adds body.modal-lock (overflow:hidden), which
     freezes scrolling. Before an in-page anchor or CTA scrolls to the offer,
     release that lock (and dismiss the promo popup) so the page can move. */
  var releaseScrollLock = function () {
    var openPopEl = document.querySelector('.pop.open');
    if (openPopEl) { openPopEl.classList.remove('open'); openPopEl.setAttribute('aria-hidden', 'true'); }
    document.body.classList.remove('modal-lock');
  };

  /* On the Tyler page the real scroll container is <body> (the Shopify theme
     caps body height to 100vh), while elsewhere it's the window — so
     window.scrollTo silently no-ops here. Detect whichever element actually
     scrolls and move it, offset for the sticky announcement bar. */
  var smoothScrollToEl = function (el) {
    var off = parseInt(getComputedStyle(document.body).paddingTop, 10) || 80;
    var delta = el.getBoundingClientRect().top - off;
    var docEl = document.scrollingElement || document.documentElement;
    var target = docEl.scrollHeight > docEl.clientHeight + 1 ? window : document.body;
    if (target.scrollBy) { try { target.scrollBy({ top: delta, behavior: 'smooth' }); return; } catch (e) {} }
    target.scrollBy(0, delta);
  };

  /* slide-in cart: offer-section CTAs open it; every other CTA scrolls to the offer section */
  var cartDrawer = document.getElementById('cartDrawer');
  if (cartDrawer) {
    /* 5-minute "cart reserved" countdown — starts on first open, persists across opens */
    var cartTimerEl = document.getElementById('cartTimer');
    var cartEnd = 0, cartInt = null, pad2 = function (n) { return String(n).padStart(2, '0'); };
    var renderCartTimer = function () {
      if (!cartTimerEl) return;
      var d = Math.max(0, cartEnd - Date.now());
      cartTimerEl.textContent = Math.floor(d / 60000) + ':' + pad2(Math.floor((d % 60000) / 1000));
      if (d <= 0 && cartInt) { clearInterval(cartInt); cartInt = null; }
    };
    var startCartTimer = function () {
      var now = Date.now();
      if (!cartEnd || cartEnd - now <= 0) cartEnd = now + 5 * 60 * 1000;   // (re)start a fresh 5:00 if none/expired
      renderCartTimer();
      if (!cartInt) cartInt = setInterval(renderCartTimer, 1000);
    };

    var openCart = function () {
      cartDrawer.classList.add('open');       // display:block
      void cartDrawer.offsetWidth;            // reflow so the transition runs from the off-screen state
      cartDrawer.classList.add('show');       // slide in + fade overlay
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      startCartTimer();
    };
    var closeCart = function () {
      cartDrawer.classList.remove('show');    // slide out
      cartDrawer.setAttribute('aria-hidden', 'true');
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      setTimeout(function () { if (!cartDrawer.classList.contains('show')) cartDrawer.classList.remove('open'); }, 440);
    };
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) { el.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCart();
    });

    var scrollToBuy = function () {
      var buy = document.getElementById('buy');
      if (!buy) return;
      releaseScrollLock();   // an open popup's modal-lock (overflow:hidden) would otherwise freeze this scroll
      smoothScrollToEl(buy);
    };
    /* Fire a CTA-click event into whatever analytics the store has (Meta Pixel, GA4, GTM dataLayer).
       Lets you gauge interest = how many people click a buy CTA. The button_text/location params let
       you isolate the actual "Claim Offer" buttons from the other CTAs in reports. No-op on the
       standalone page (none of these globals exist there). */
    var trackCTA = function (el) {
      var label = (el.textContent || '').replace(/\s+/g, ' ').trim();
      var where = el.closest('#buy') ? 'offer'
                : el.closest('.bar') ? 'announcement'
                : el.closest('.hero') ? 'hero'
                : el.closest('.final') ? 'final'
                : el.closest('.pop') ? 'popup'
                : el.closest('.modal') ? 'modal' : 'other';
      try { if (window.fbq) fbq('trackCustom', 'ClaimOfferClick', { button_text: label, location: where }); } catch (e) {}
      try { if (window.gtag) gtag('event', 'claim_offer_click', { button_text: label, location: where }); } catch (e) {}
      try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'claim_offer_click', button_text: label, location: where }); } catch (e) {}
    };
    document.querySelectorAll('.js-checkout').forEach(function (el) {
      var inOffer = !!el.closest('#buy');
      el.addEventListener('click', function (e) {
        e.preventDefault();
        trackCTA(el);                // record the click for interest tracking
        if (inOffer) openCart();     // Claim Offer + "You save $529" open the cart
        else scrollToBuy();          // all other CTAs bring the user to the offer section
      });
    });
  }

  /* ---------- promo popup (car matcher + email capture) ---------- */
  /* ====== KLAVIYO SETUP: paste your two values below ======
     KLAVIYO_PUBLIC_KEY = your public API key (a.k.a. Company/Site ID, 6 chars)
     KLAVIYO_LIST_ID    = the List ID you want subscribers added to
     Leave them blank to run in demo mode (no network call).            */
  var KLAVIYO_PUBLIC_KEY = 'T9Ldwz';
  var KLAVIYO_LIST_ID = 'UgvmRt';
  var POPUP_DELAY_MS = 5000;   // show 5s after landing
  var PROMO_CODE = 'CRX2000';

  var POPUP_ENABLED = true;   // promo popup enabled. Set to false to temporarily turn it off.
  var pop = POPUP_ENABLED && document.getElementById('promoPop');
  if (pop) {
    var SEEN_KEY = 'innova_promo_seen';
    var steps = {};
    pop.querySelectorAll('.pop-step').forEach(function (s) { steps[s.getAttribute('data-step')] = s; });
    var showStep = function (n) {
      Object.keys(steps).forEach(function (k) { steps[k].hidden = (k !== String(n)); });
    };
    var initScratch = null;   // assigned below; called on open so the canvas has real dimensions
    var openPop = function () {
      if (pop.classList.contains('open')) return;
      pop.classList.toggle('pop--promo', promoActive);   // flash-sale variant during a promo
      pop.classList.add('open');
      pop.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-lock');
      if (initScratch) initScratch();
    };
    var popTab = document.getElementById('popTab');
    var showTab = function () { if (popTab) { popTab.hidden = false; popTab.classList.add('show'); } };
    var hideTab = function () { if (popTab) { popTab.classList.remove('show'); popTab.hidden = true; } };
    var closePop = function () {
      pop.classList.remove('open');
      pop.setAttribute('aria-hidden', 'true');
      try { localStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
      if (!document.querySelector('.modal.open')) document.body.classList.remove('modal-lock');
      if (!emailCaptured) showTab();      // minimize to a re-openable corner tab (unless they signed up)
    };
    if (popTab) popTab.addEventListener('click', function () { hideTab(); openPop(); });
    pop.querySelectorAll('[data-pop-close]').forEach(function (el) { el.addEventListener('click', closePop); });
    pop.querySelectorAll('[data-pop-goto]').forEach(function (el) {
      el.addEventListener('click', function () { showStep(promoActive ? '5' : el.getAttribute('data-pop-goto')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) closePop(); });

    /* jackpot claim countdown (starts when the jackpot step appears) */
    var jpTimerEl = document.getElementById('jpTimer');
    var jpEnd = 0, jpInt = null;
    var startJpTimer = function () {
      if (!jpTimerEl) return;
      if (!jpEnd) jpEnd = Date.now() + 10 * 60 * 1000;
      var r = function () { var d = Math.max(0, jpEnd - Date.now()); jpTimerEl.textContent = Math.floor(d / 60000) + ':' + pad2(Math.floor((d % 60000) / 1000)); if (d <= 0 && jpInt) { clearInterval(jpInt); jpInt = null; } };
      r(); if (!jpInt) jpInt = setInterval(r, 1000);
    };

    /* scratch-off: swipe/drag to reveal the discount, then advance to email */
    var scratch = document.getElementById('scratch');
    var canvas = document.getElementById('scratchCanvas');
    if (scratch && canvas && canvas.getContext) {
      var sctx = canvas.getContext('2d');
      var sized = false, scratching = false, revealed = false, lastPt = null;

      initScratch = function () {
        if (sized) return;
        var r = scratch.getBoundingClientRect();
        if (!r.width) return;                       // still hidden; will retry on next open call
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(r.width * dpr);
        canvas.height = Math.round(r.height * dpr);
        sctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var g = sctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#cbd0d8'); g.addColorStop(.5, '#aab0ba'); g.addColorStop(1, '#cbd0d8');
        sctx.fillStyle = g; sctx.fillRect(0, 0, r.width, r.height);
        sized = true;
      };

      var relPos = function (e) {
        var r = canvas.getBoundingClientRect();
        var t = e.touches && e.touches[0];
        return { x: (t ? t.clientX : e.clientX) - r.left, y: (t ? t.clientY : e.clientY) - r.top };
      };
      var eraseAt = function (x, y) {
        sctx.globalCompositeOperation = 'destination-out';
        sctx.beginPath(); sctx.arc(x, y, 22, 0, Math.PI * 2); sctx.fill();
        if (lastPt) { sctx.lineWidth = 44; sctx.lineCap = 'round'; sctx.beginPath();
          sctx.moveTo(lastPt.x, lastPt.y); sctx.lineTo(x, y); sctx.stroke(); }
        lastPt = { x: x, y: y };
      };
      var pctCleared = function () {
        try {
          var d = sctx.getImageData(0, 0, canvas.width, canvas.height).data, clear = 0, total = 0;
          for (var i = 3; i < d.length; i += 4 * 24) { total++; if (d[i] === 0) clear++; }
          return total ? clear / total : 0;
        } catch (e) { return 0; }
      };
      var reveal = function () {
        if (revealed) return; revealed = true;
        sctx.clearRect(0, 0, canvas.width, canvas.height);
        scratch.classList.add('revealed');
        setTimeout(function () {
          if (promoActive) { showStep('5'); }              // -> flash-sale shop step (no email during a sale)
          else { showStep(2); startJpTimer(); }            // -> jackpot celebration
        }, 950);
      };
      var scratchMove = function (e) {
        if (!scratching || revealed) return;
        if (e.cancelable) e.preventDefault();
        var p = relPos(e); eraseAt(p.x, p.y);
        if (pctCleared() > 0.5) reveal();
      };
      var scratchStart = function (e) {
        if (!sized) initScratch();
        scratching = true; lastPt = null; scratch.classList.add('scratching');
        scratchMove(e);
      };
      var scratchEnd = function () { scratching = false; lastPt = null; };

      canvas.addEventListener('mousedown', scratchStart);
      window.addEventListener('mousemove', scratchMove);
      window.addEventListener('mouseup', scratchEnd);
      canvas.addEventListener('touchstart', scratchStart, { passive: false });
      canvas.addEventListener('touchmove', scratchMove, { passive: false });
      window.addEventListener('touchend', scratchEnd);
    }

    /* email submit -> Klaviyo */
    var form = document.getElementById('popForm');
    var emailIn = document.getElementById('popEmail');
    var errEl = document.getElementById('popErr');
    var codeEl = document.getElementById('popCode');
    if (codeEl) codeEl.textContent = PROMO_CODE;
    var validEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); };

    var subscribe = function (email, props) {
      if (!KLAVIYO_PUBLIC_KEY || !KLAVIYO_LIST_ID) return Promise.resolve('demo');
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_PUBLIC_KEY), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: '5610 Landing Popup',
              profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        })
      }).then(function (r) { if (!r.ok) throw new Error('Klaviyo ' + r.status); return r; });
    };

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailIn.value || '').trim();
        if (!validEmail(email)) { if (errEl) errEl.hidden = false; emailIn.focus(); return; }
        if (errEl) errEl.hidden = true;
        var btn = form.querySelector('.pop-submit');
        btn.disabled = true; var label = btn.textContent; btn.textContent = 'Signing you up…';
        subscribe(email, {}).then(function () {
          try { localStorage.setItem(SEEN_KEY, '1'); localStorage.setItem('innova_email_captured', '1'); } catch (er) {}
          emailCaptured = true; hideTab();   // they signed up: no minimize tab
          setCheckout(CART_EMAIL);           // add the CRX2000 discount now that we have the email
          showStep(4);
        }).catch(function () {
          btn.disabled = false; btn.textContent = label;
          if (errEl) { errEl.hidden = false; errEl.textContent = 'Something went wrong — please try again.'; }
        });
      });
    }

    /* fire 5s after landing; if already seen but not signed up, keep the re-open tab available */
    var seen = false; try { seen = !!localStorage.getItem(SEEN_KEY); } catch (e) {}
    if (!seen) setTimeout(openPop, POPUP_DELAY_MS);      // shows jackpot (normal) or flash-sale (promo) variant
    else if (!emailCaptured) showTab();
  }

  /* ---------- anchor scrolling ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      releaseScrollLock();   // release any modal-lock so the anchor can actually scroll
      smoothScrollToEl(el);
    });
  });

  /* ---------- come back to this tab: alert the title + favicon when the user leaves ---------- */
  (function () {
    var origTitle = document.title;
    var favEl = document.querySelector('link[rel~="icon"]');
    if (!favEl) { favEl = document.createElement('link'); favEl.rel = 'icon'; document.head.appendChild(favEl); }
    // On Shopify our section (and its <link rel="icon">) renders inside <body>, where browsers
    // ignore it — so the tab shows no favicon and the dot swap has nothing to affect. Move it into
    // <head> so the icon actually displays. No-op on the standalone page (link is already in <head>).
    else if (!favEl.closest('head')) { document.head.appendChild(favEl); }
    var origHref = favEl.getAttribute('href');
    var badgedHref = null;

    // build a copy of the favicon with a red notification dot
    var img = new Image();
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = 32; c.height = 32;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, 32, 32);
        ctx.beginPath(); ctx.arc(23, 9, 8, 0, 2 * Math.PI);
        ctx.fillStyle = '#da291c'; ctx.fill();
        ctx.lineWidth = 2.5; ctx.strokeStyle = '#fff'; ctx.stroke();
        badgedHref = c.toDataURL('image/png');
      } catch (e) { /* canvas blocked, title alert still works */ }
    };
    if (origHref) img.src = origHref;

    var ALERTS = ['🔴 Your deal is waiting', '👋 Come back for $200 OFF'];
    var flip = null, i = 0;
    var setFav = function (h) { if (h) favEl.setAttribute('href', h); };

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        setFav(badgedHref);
        i = 0; document.title = ALERTS[0];
        if (!flip) flip = setInterval(function () {
          i = (i + 1) % (ALERTS.length + 1);
          document.title = i === 0 ? origTitle : ALERTS[i - 1];   // blink between the real title and the alerts
        }, 1400);
      } else {
        if (flip) { clearInterval(flip); flip = null; }
        document.title = origTitle;
        setFav(origHref);
      }
    });
  })();
})();
